<div class="grid m-0">
  <div class="flex flex-column gap-2 pl-0 col-12 md:col-4">
    <h2 class="m-0" data-test-id="colorFamilyNameHeadline">{{ resources().colorFamily | resourceValue }}</h2>
    @for (family of colorFamilies(); track $index) {
      <p-button
        styleClass="text-left p-0"
        [attr.data-test-id]="'colorSpecification.colorFamilyName.' + family.name"
        [label]="family.name"
        [link]="true"
        (onClick)="onColorFamilyClick(family.name, family.link.path, family.link.fragment)">
      </p-button>
    }
  </div>
  <div class="flex flex-column gap-2 col-12 md:col-4">
    @if (colorSpecification().colorCollectionNames && colorSpecification().colorCollectionNames.length > 0) {
      <h2 class="m-0" data-test-id="colorCollectionHeadline">{{ resources().collection | resourceValue }}</h2>
      @for (collection of colorSpecification().colorCollectionNames; track $index) {
        <p-button
          styleClass="text-left p-0"
          [attr.data-test-id]="'colorSpecification.colorCollectionName.' + collection"
          [label]="collection"
          [link]="true"
          [routerLink]="[formatPath(colorCollectionPath()), formatPath(collection)]"
          (onClick)="onColorCollectionClick(collection)">
        </p-button>
      }
    }
  </div>
  <div class="flex flex-column gap-2 col-12 md:col-4">
    @if (colorDataEnabled()) {
      <h2 class="m-0" data-test-id="colorDataHeadline">{{ resources().colorData | resourceValue }}</h2>
      @if (rgbEnabled()) {
        <p class="m-0" data-test-id="rgbData">{{ colorSpecification().colorData.rgb | formatRgb }}</p>
      }
      @if (lrvEnabled()) {
        <p class="m-0" data-test-id="lrvData">LRV: {{ colorSpecification().colorData.lrv }}</p>
      }
      @if (ncsEnabled()) {
        <p class="m-0" data-test-id="ncsData">NCS: {{ colorSpecification().colorData.ncs }}</p>
      }
    }
  </div>
</div>
